// extracted by mini-css-extract-plugin
export var active = "_ew-7";
export var blink = "_ew-8";
export var dropDownSelector = "_ew-4";
export var dropDownWrapper = "_ew-3";
export var fakeCursor = "_ew-6";
export var fontSizeButton = "_ew-9";
export var formQuillEditor = "_ew-0";
export var pressed = "_ew-a";
export var qlBlank = "_ew-1";
export var textFormattingToolbar = "_ew-2";
export var textToolbarOption = "_ew-5";